import React, { useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useMembership, useUser } from '../../hooks/users';

const Styles = styled.div`
  .purchase-button {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 4rem;
    z-index: 1044;
    padding: 0.5rem 1rem;
    font-size: 1rem;
  }
`;

interface Props {
  appendText?: string;
}

// this is a button only shows up when user is not a VIP
// it is always staying on top of everything else.
const PurchaseVIPFloatButton: React.FC<Props> = ({ appendText }) => {
  const hasMembership = useMembership();
  const user = useUser();
  const { t } = useTranslation();

  const nagivate = useNavigate();
  const handleClick = useCallback(() => {
    if (user) {
      nagivate('/payment');
    } else {
      nagivate('/register');
    }
  }, [nagivate, user]);

  return (
    <Styles>
      {!hasMembership && (
        <Button
          className="purchase-button"
          variant="dark"
          onClick={handleClick}
        >
          {user ? t('purchase-vip-to-unlock-all') : t('register-to-see-more')}
          {appendText}
        </Button>
      )}
    </Styles>
  );
};

export default PurchaseVIPFloatButton;
